var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-padding uk-background-muted"},[_c('div',{staticClass:"uk-container"},[_c('h1',[_vm._v(_vm._s(this.$route.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }